import {http, onSuccess, onFail} from "./http";

export const eventSubscribeTelephone = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/subscribe/phone`, data)
        .then(onSuccess, onFail);

export const eventSubscribeTelephoneCode = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/subscribe/phone/code`, data)
        .then(onSuccess, onFail);

export const eventSubscribeEmail = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/subscribe/email`, data)
        .then(onSuccess, onFail);

export  const eventSubscribeEmailCode = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/subscribe/email/code`, data)
        .then(onSuccess, onFail);

export const eventSubscribePush = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/subscribe/push`, data)
        .then(onSuccess, onFail);

export const eventSubscribeGet = (eventKey) =>
    http.get(`/api/player/event/${eventKey}/subscribe`)
        .then(onSuccess, onFail);
